import { inject, ref } from 'vue';

function createDefaultErrorObject() {
    return ref({
        messages: [],
        recommendedActions: [],
        keys: [],
        clear: () => {},
    });
}

export function useInjectedErrors() {
    return {
        general: inject('general-errors', createDefaultErrorObject()),
        cvErrors: inject('cv-errors', createDefaultErrorObject()),
        mailErrors: inject('mail', createDefaultErrorObject()),
    };
}
